const state = () => ({
  snack: '',
  type: 'success'
})

const getters = {
  snack: state => state.snack,
  type: state => (state.type) ? state.type : 'success',
}

const mutations = {
  setSnack(state, payload) {
    state.snack = payload.snack
    state.type = payload.type
  }
}

const actions = {
  setSnack: ({ commit }, payload) => {
    commit('setSnack', payload)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
}
